import { Spin } from "antd";
import React from "react";

const SpinnerNoPercet = () => {
  return (
    <>
      <Spin
        spinning={true}
        percent={"auto"}
        fullscreen
        size="large"
        tip="Loading..."
      />
    </>
  );
};

export default SpinnerNoPercet;
